// Utility functions to handle avatar strings from the backend

export const isAvatarString = (
  profilePicture: string | undefined | null
): boolean => {
  return (
    typeof profilePicture === "string" && profilePicture.startsWith("avatar:")
  );
};

export const extractAvatarInfo = (avatarString: string) => {
  if (!isAvatarString(avatarString)) return null;

  const parts = avatarString.split(":");
  if (parts.length !== 3) return null;

  return {
    color: parts[1],
    initial: parts[2],
  };
};

export const generateAvatarUrl = (
  profilePicture: string | undefined | null
): string => {
  // If no profile picture or empty string, return placeholder
  if (!profilePicture || profilePicture.trim() === "") {
    return "https://via.placeholder.com/40x40/3B82F6/FFFFFF?text=U";
  }

  // If it's an avatar string (e.g., "avatar:#C2185B:F"), convert to SVG data URL
  if (isAvatarString(profilePicture)) {
    const avatarInfo = extractAvatarInfo(profilePicture);
    if (avatarInfo) {
      const { color, initial } = avatarInfo;

      // Create SVG data URL for the avatar
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
          <rect width="40" height="40" fill="${color}"/>
          <text x="20" y="26" font-family="Arial, sans-serif" font-size="16" font-weight="bold" text-anchor="middle" fill="white">${initial}</text>
        </svg>
      `.trim();

      return `data:image/svg+xml;base64,${btoa(svg)}`;
    }
  }

  // If it's a regular URL, return as is
  return profilePicture;
};

export const getAvatarFallback = (firstName?: string): string => {
  const initial = firstName ? firstName.charAt(0).toUpperCase() : "U";
  return `https://via.placeholder.com/40x40/3B82F6/FFFFFF?text=${initial}`;
};
